import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AddNewSiteForm from "../../components/AddNewProject/AddNewSiteForm";

export default function AddNewProject() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  const [formData, setFormData] = useState({
    partnerName: {
      value: "",
      error: false,
      errorMessage: "Partner Name is required",
    },
    projectName: {
      value: "",
      error: false,
      errorMessage: "Principle name is required",
    },
    corporationName: {
      value: "",
      error: false,
      errorMessage: "Corporation name is required",
    },
    premiumness: {
      value: "",
      error: false,
      errorMessage: "Premiumness is required",
    },
    status: {
      value: "data entry",
      error: true,
    },
    desc: {
      value: "",
      error: false,
      errorMessage: "Description is required",
    },
    zone: {
      value: "",
      error: false,
      errorMessage: "Zone is required",
    },
    state: {
      value: "",
      error: false,
      errorMessage: "State is required",
    },
    city: {
      value: "",
      error: false,
      errorMessage: "City is required",
    },
    profile: {
      value: "",
      error: false,
      errorMessage: "Profile required",
    },
    priority: {
      value: "",
      error: false,
      errorMessage: "Priority required",
    },
    assetLocationName: {
      value: "",
      error: true,
    },
    landmark: {
      value: "",
      error: true,
    },
    latitude: {
      value: "",
      error: true,
    },
    longitude: {
      value: "",
      error: true,
    },
    principleUid: {
      value: "",
      error: true,
    },
    packageId: {
      value: "",
      error: true,
    },
    package_name: {
      value: "",
      error: false,
      errorMessage: "Package name is required",
    },
    package_rate: {
      value: "",
      error: true,
    },
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        // height: "100vh",
        backgroundColor: "#fff",
        gap: 2,
        // border: "1px solid black",
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "0 20px",
          height: "10vh",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
          //   border: "1px solid blue",
        }}
      >
        <Typography sx={{ fontSize: "24px", fontWeight: 600 }}>
          Create New Site
        </Typography>
      </Box>

      {/* Content Section */}
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <Box
          sx={{
            width: "80%",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
            justifyContent: "space-between",
            // border: "1px solid black",
          }}
        >
          <Box>
            <AddNewSiteForm formData={formData} setFormData={setFormData} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
